import { ADULTS, CHILDREN, NIGHTS, START_DATE } from 'contexts/CruiseSearchContext/constants';
import { mapCriteriaToQuery } from '..';
import { PROMOTION_STATUS_ACTIVE } from '../../../components/TargetedOffers/Components/Banner/Constants';
import { doMultiDateRangesOverlap, getDateRangesOverlap } from '../dateRangesOverlap/dateRangesOverlap';
import { doNightRangesOverlap, getNightRangesOverlap } from '../nightRangesOverlap/nightRangesOverlap';

const CRITERIA_ALLOWED_FILTERS = [ADULTS, CHILDREN];

export const mapStartDate = ({ searchSelecting, criteriaDate = [] }) => {
	const { startDate: datesSearch = [] } = searchSelecting || {};
	if (datesSearch.length === 0 || criteriaDate.length === 0) {
		return criteriaDate;
	}

	return getDateRangesOverlap({
		criteriaDateRanges: criteriaDate,
		searchDateRanges: datesSearch,
	});
};

const mapNights = ({ searchSelecting, criteriaNights }) => {
	return getNightRangesOverlap({
		searchRanges: searchSelecting.nights ?? [],
		criteriaRanges: criteriaNights ?? [],
	});
};

const mapFilters = (filters, searchSelecting) => {
	return Object.keys(filters || {}).reduce((acc, cur) => {
		const currentFilter = filters[cur] || [];
		const currentSearch = searchSelecting[cur] || [];
		if (currentSearch.length > 0) {
			acc[cur] = currentFilter.filter((val) => currentSearch.includes(val));
			return acc;
		}
		acc[cur] = currentFilter;
		return acc;
	}, {});
};

const mapOccupancy = (searchSelecting) => {
	const { adults, children } = searchSelecting;

	return { adults, children };
};

export const mergeQuerys = ({ promotions, searchSelecting = {}, querySearch, promotionApplied }) => {
	const { valid, status, queryCriteria, criteria: listCriteria = [] } = promotions;
	if (status !== PROMOTION_STATUS_ACTIVE) {
		return {
			isEmpty: false,
			querySearch,
		};
	}
	if (!valid || listCriteria.length === 0 || !promotionApplied) {
		return {
			isEmpty: false,
			querySearch,
		};
	}

	const initQueryCriteria = queryCriteria;

	const hadSearchSelecting = Object.keys(searchSelecting || {}).length > 0;
	if (!hadSearchSelecting) {
		return {
			isEmpty: false,
			querySearch: initQueryCriteria,
		};
	}

	const applyCriteria = listCriteria.filter((criteria) => {
		return Object.keys(searchSelecting).every((filter) => {
			if (CRITERIA_ALLOWED_FILTERS.includes(filter)) {
				return true;
			}

			const searchs = searchSelecting[filter];
			if (searchs.length === 0) {
				return true;
			}

			if (filter === START_DATE) {
				return doMultiDateRangesOverlap({
					searchDateRanges: searchs,
					criteriaDateRanges: criteria[filter] ?? [],
				});
			}

			if (filter === NIGHTS) {
				return doNightRangesOverlap({
					searchRanges: searchs,
					criteriaRanges: criteria[filter] ?? [],
				});
			}

			return searchs.some((search) => {
				return criteria[filter]?.includes(search);
			});
		});
	});

	const result = applyCriteria.map((val) => {
		const { startDate = [], nights = [], ...othersFilters } = val;
		const filters = mapFilters(othersFilters, searchSelecting);
		return {
			...filters,
			...mapOccupancy(searchSelecting),
			nights: mapNights({ searchSelecting, criteriaNights: nights }),
			startDate: mapStartDate({ searchSelecting, criteriaDate: startDate }),
		};
	});

	if (result.length > 0) {
		return {
			isEmpty: false,
			querySearch: mapCriteriaToQuery({ criteria: result }),
		};
	}
	return {
		isEmpty: true,
		querySearch: initQueryCriteria,
	};
};
